<template>
    <div class="wrapper">
        <FORM ref="childForm" @formclick="formClick" :formData="formData"></FORM>
        <table-page ref="childTable" @btnclick="btnClick" :pageData="pageData"></table-page>
        <UPDATE ref="childAdd" @submit="addAppProductSubmit" :updateData="addAppProductData"></UPDATE>
        <UPDATE ref="childUpdate" @submit="updateAppProductSubmit" :updateData="updateAppProductData"></UPDATE>
        <!-- <UPDATE ref="childDelete" @submit="deleteAppProductSubmit" :updateData="deleteAppProductData"></UPDATE> -->
    </div>
</template>

<script>
    import tablePage from '../components/page/table.vue'
    import FORM from '../components/page/form.vue'
    import UPDATE from '../components/page/update.vue'
    import URL from '@/views/mis/util/url'
    import Qs from 'qs'
    import DATA from '@/views/mis/util/data'
    // import store from '@/store'

    let userInfo = {};
    let gts2ProductList = [];
    let gts2ProductOptions = [];
    let fxList = [];
    let goodsList = [];
    let indexList = [];
    let stockList = [];
    let cryptoList = [];
    let appProductAmount = "";
    let channelOptionList=[];//广告渠道及渠道app
    let channelAppMasterList=[]; //广告渠道app总List
    let channelAppList=[]//广告渠道app选单List
    let platformList=[];//适用平台
    let accountTypeList=[];//适用用户

    const queryParams = {
        chineseName: "",
        englishName: "",
        deviceOs: "",
        accountType: "",
        channel: "",
    }

    export default {
        name: 'product',
        components: {
            tablePage,
            FORM,
            UPDATE
        },
        methods: {
            formClick(clickName, data) {
                // console.log("Form clicked." + clickName, data);
                if ("查询" == clickName || window.$t("mis.appProduct.button.queryAppProduct") == clickName) {
                    let params = {...queryParams};
                    if(data.chineseName) {params.chineseName = data.chineseName;}
                    if(data.englishName) {params.englishName = data.englishName;}
                    if(data.platform && data.platform.length > 0) {
                        // params.platform = data.platform.reduce((acc, cur) => acc + "," + cur);
                        params.deviceOs = data.platform;
                    }
                    if(data.accountType && data.accountType.length > 0) {
                        // params.accountType = data.accountType.reduce((acc, cur) => acc + "," + cur);
                        params.accountType = data.accountType;
                    }
                    if(data.channel) {
                        params.channel = data.channel + "_" + channelAppMasterList.filter(channel => channel.id === data.channel)[0].name;
                    }
                    // console.log("Form clicked.", params);
                    this.$refs.childTable.defaultQueryData(params);
                } else if (clickName == window.$t("mis.appProduct.button.addAppProduct")) {
                    this.$refs.childAdd.open();
                } else if (clickName == window.$t("mis.appProduct.button.setAmountField")) {
                    this.setProductAmountSubmit(data);
                }
            },
            btnClick(clickName, row) {
                // console.log("Button clicked.", row);
                if (clickName == 'update') {
                    let platformKeys = [];
                    if(row.platform){
                        let platforms = row.platform.split(",");
                        platformKeys = platforms.map(value => platformList.filter(e => e.value === value)[0].key);
                    }
                    let accountTypeKeys = [];
                    if(row.accountType){
                        let accountTypes = row.accountType.split(",");
                        accountTypeKeys = accountTypes.map(value => accountTypeList.filter(e => e.value === value)[0].key);
                    }
                    let channelIds = [];
                    if(row.channel){
                        let channels = row.channel.split(",");
                        channelIds = channels.map(name => channelAppMasterList.filter(e => e.name === name)[0].id);
                    }
                    // console.log("Update - channel.", channelIds);
                    let modal = {
                        id: row.id,
                        code: row.code,
                        chineseName: row.chineseName,
                        englishName: row.englishName,
                        channel: channelIds,
                        platform: platformKeys,
                        accountType: accountTypeKeys,
                        order: row.order
                    }
                    this.$refs.childUpdate.open(modal);
                } else if (clickName == 'delete') {
                    this.$confirm(window.$t("common.ifDelete"), window.$t("common.tip"), {
                        // distinguishCancelAndClose: true,
                        confirmButtonText: window.$t("common.ok"),
                        cancelButtonText: window.$t("common.canceld")
                    }).then(
                        // this.deleteAppProductSubmit(row)
                        () => {
                            this.$axios.get(URL.appProduct.delete, { params: { id: row.id, userName: userInfo.displayName } }).then(res=> {
                                if (res.code == 0) {
                                    this.$message.success("Successfully Deleted.");
                                    this.$refs.childTable.defaultQueryData(queryParams);
                                }else{
                                    this.$message.error(res.message);
                                }
                            });
                        }
                    );
                }
            },
            addAppProductSubmit(modal) {
                // console.log("Add App Product Data.", modal);
                let formData = this.updateModalDataTransfer(modal);
                let payload = {
                    userName: userInfo.displayName,
                    ...formData
                }
                // console.log("Add App Product Payload.", payload);
                this.dataRequest(URL.appProduct.add, payload, res => {
                    if (res.code == 0){
                        this.$refs.childAdd.close();
                        if (res.result) {
                            this.$message.success("Successfully Added.");
                            this.$refs.childTable.defaultQueryData(queryParams);
                        } else {
                            this.$message.error("Failed to add the app product.");
                        }
                    } else{
                        this.$message.error(res.message);
                    }
                })
            },
            updateAppProductSubmit(modal) {
                // console.log("Update App Product Data.", modal);
                let formData = this.updateModalDataTransfer(modal);
                let payload = {
                    id: modal.id,
                    userName: userInfo.displayName,
                    ...formData
                }
                // console.log("Update App Product Payload.", payload);
                this.dataRequest(URL.appProduct.update, payload, res => {
                    if (res.code == 0){
                        this.$refs.childUpdate.close();
                        this.$message.success("Successfully Updated.");
                        this.$refs.childTable.defaultQueryData(queryParams);

                    }else{
                        this.$message.error(res.message);
                    }
                })
            },
            updateModalDataTransfer(modal) {
                let accountType = "";
                let platform = "";
                let channel = "";
                if (modal.accountType.length > 1) {
                    accountType = modal.accountType.reduce((acc, cur) => acc + "," + cur);
                } else {
                    accountType = modal.accountType[0];
                }
                if (modal.platform.length > 1) {
                    platform = modal.platform.reduce((acc, cur) => acc + "," + cur);
                } else {
                    platform = modal.platform[0];
                }
                // Pattern {channelId}_{channelName}
                if (modal.channel.length > 1) {
                    channel = modal.channel.map(id => id + "_" + channelAppMasterList.filter(e => e.id == id)[0].name);
                    channel = channel.join(",")
                } else {
                    channel = modal.channel[0] + "_" + channelAppMasterList.filter(e => e.id === modal.channel[0])[0].name;
                }
                let productInfo = gts2ProductList.filter(item => item.code == modal.code)[0];
                return {
                    ...productInfo,
                    accountType: accountType,
                    platform: platform,
                    channel: channel,
                    order: modal.order
                }
            },
            deleteAppProductSubmit(modal) {
                // console.log("Delete App Product Data.", modal);
                this.$axios.get(URL.appProduct.delete, { params: { id: modal.id, userName: userInfo.displayName } }).then(res=> {
                    if (res.code == 0) {
                        this.$message.success("Successfully Deleted.");
                        this.$refs.childTable.defaultQueryData(queryParams);
                    }else{
                        this.$message.error(res.message);
                    }
                });
            },
            setProductAmountSubmit(data) {
                // console.log("Set App Product Amount Data.", data);
                this.$axios.get(URL.appProduct.setCallbackAppProductAmount, { params: { amount: data.amount } }).then(res=> {
                    if (res.code == 0) {
                        appProductAmount = data.amount;
                        this.$message.success("Successfully Set Amount.");
                    }else{
                        this.$message.error(res.message);
                    }
                });
            },
            dataRequest(url,option,suc,fail) {
                // console.log("Data Request Payload", option);
                this.$axios.post(url, JSON.stringify(option || {}), {headers: { 'content-type': 'application/json' }}).then(res => {
                    if(suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if(fail && (typeof fail == 'function')) fail(res);
                })
            },
            getAppProductAmount() {
                this.$axios.get(URL.appProduct.getCallbackAppProductAmount).then(res => {
                    if (res.code == 0) {
                        if (res.result > -1) {
                            appProductAmount = res.result; 
                            this.$set(this.formData.cols, 8, {
                                title: window.$t("mis.appProduct.other.setAmountFieldLabel"), placeholder: window.$t("mis.appProduct.setAmountFieldPlaceholder"), type: 7, max: 15 ,field: "amount", data: appProductAmount, paddingRight:true
                            })
                        }
                    } else {
                        this.$message.error(res.message);
                    }
                })
            },
            getMetaData() {
                this.$axios.get(URL.appProduct.metaData + "?type=option").then(res => {
                    if (res.code == 0) {
                        let responseData = res.result.list ? res.result.list : res.result;
                        if (responseData) {
                            // Handle platform data
                            let platformData = responseData.platform;
                            platformList = platformData.sort((a, b) => a.id - b.id).map(({id, key, value}) => ({id, key: value, value: key}));
                            // console.log("Platform List: ", platformList);
                            this.$set(this.formData.cols, 2, {
                                title: window.$t("mis.appProduct.queryForm.label.platform"), field: "platform", type: 2, optionList: platformList
                            })

                            // Handle account type data
                            let accountTypeData = responseData.accountType;
                            accountTypeList = accountTypeData.map(({id, key, value}) => ({id, key: value, value: key}))
                            // console.log("AccountType List: ", accountTypeList);
                            this.$set(this.formData.cols, 3, {
                                title: window.$t("mis.appProduct.queryForm.label.accountType"), field: "accountType",type:2,optionList: accountTypeList
                            })
                        }
                    } else {
                        this.$message.error(res.message);
                    }
                });
                this.$axios.get(URL.appProduct.metaData + "?type=channel").then(res => {
                    if (res.code == 0) {
                        let responseData = res.result.list ? res.result.list : res.result;
                        if (responseData) {
                             // Handle channel data
                             let channelData = responseData.channel;
                            channelOptionList = channelData.map(({channelKey, channelName, channelApps}) => ({value: channelKey, label: channelName, children: channelApps}))
                            channelOptionList = channelOptionList.map(item => {
                                return {
                                    ...item,
                                    children: item.children.map(({id, name}) => ({value: id, label: name}))
                                }});
                            // console.log("Channel Option List: ", channelOptionList);
                            channelAppMasterList = channelData.flatMap(item => item.channelApps);
                            // console.log("Channel App Master List: ", channelAppMasterList);
                            channelAppList = channelAppMasterList.map(({id, name}) => ({key: id, value: name}));
                            // console.log("Channel App List: ", channelAppList);
                            this.$set(this.formData.cols, 4, {
                                title: window.$t("mis.appProduct.queryForm.label.channel"), field: "channel",type:2, optionList:channelAppList
                            })
                        }
                    } else {
                        this.$message.error(res.message);
                    }
                });
                this.$axios.get(URL.appProduct.metaData + "?type=gts2").then(res => {
                    if (res.code == 0) {
                        let responseData = res.result.list ? res.result.list : res.result;
                        if (responseData) {
                            // Handle Gts2 data
                            let gts2Data = responseData.gts2;
                            fxList = gts2Data.fxList;
                            goodsList = gts2Data.goodsList;
                            indexList = gts2Data.indexList;
                            stockList = gts2Data.stockList;
                            cryptoList = gts2Data.cryptoList;
                            gts2ProductList.push(fxList, goodsList, indexList, stockList);
                            gts2ProductList = gts2ProductList.flat();
                            // console.log("Gts2 Product List: ", gts2ProductList);
                            gts2ProductOptions = gts2ProductList.map(({code, englishName})=>({key: code, value: englishName}));
                            // console.log("Gts2 Product Option List: ", gts2ProductOptions);

                            // Set the product list to components
                            this.$set(this.addAppProductData,
                            "cols",
                            [
                                {title: "id", field: "id", hidden: true},
                                {title: window.$t("mis.appProduct.addForm.label.platform"), field: "platform", type:4, optionList:platformList, data:[], hasCheckAll:true, checkAll:false, required: true},
                                {title: window.$t("mis.appProduct.addForm.label.englishName"), field: "code", type: 2, optionList: gts2ProductOptions, required: true},
                                {title: window.$t("mis.appProduct.addForm.label.accountType"), field: "accountType", type:4, optionList: accountTypeList, data:[], hasCheckAll:true, checkAll:false},
                                {title: window.$t("mis.appProduct.addForm.label.channel"), field: "channel", type: 15, optionList: channelOptionList, expandTrigger: 'hover',multiple: true, collapse: true, emitPath: false, data: []},
                                {title: window.$t("mis.appProduct.addForm.label.sortOrder"), field: "order", type:7, data:0}
                            ]);
                            this.$set(this.updateAppProductData,
                            "cols",
                            [
                                {title: "id", field: "id", hidden: true},
                                {title: window.$t("mis.appProduct.updateForm.label.platform"), field: "platform", type:4, optionList:platformList, data:[], hasCheckAll:true, checkAll:false, required: true},
                                {title: window.$t("mis.appProduct.updateForm.label.englishName"), field: "code", type: 2, optionList: gts2ProductOptions, required: true},
                                {title: window.$t("mis.appProduct.updateForm.label.accountType"), field: "accountType", type:4, optionList: accountTypeList, data:[], hasCheckAll:true, checkAll:false},
                                {title: window.$t("mis.appProduct.updateForm.label.channel"), field: "channel", type: 15, optionList: channelOptionList, expandTrigger: 'hover',multiple: true, collapse: true, emitPath: false, data: []},
                                {title: window.$t("mis.appProduct.updateForm.label.sortOrder"), field: "order", type:7, data:0}
                            ]);
                        }
                    } else {
                        this.$message.error(res.message);
                    }
                });
            },
        },
        data () {
            return {
                formData: {
                    hasLable: true,
                    cols:[
                        {title: window.$t("mis.appProduct.queryForm.label.chineseName"), field: "chineseName"},
                        {title: window.$t("mis.appProduct.queryForm.label.englishName"), field: "englishName"},
                        {title: window.$t("mis.appProduct.queryForm.label.platform"), field: "platform", type: 2, optionList: platformList, multiple: true},
                        {title: window.$t("mis.appProduct.queryForm.label.accountType"), field: "accountType",type:2,optionList: accountTypeList, multiple: true},
                        {title: window.$t("mis.appProduct.queryForm.label.channel"), field: "channel",type:2, optionList:channelAppList},
                        {click: window.$t("mis.appProduct.button.queryAppProduct")},
                        {click: window.$t("mis.appProduct.button.addAppProduct"), auth: "sys:appProduct:add"},
                        {click: window.$t("mis.appProduct.button.setAmountField"), auth: "sys:appProduct:setAmount", paddingRight:true },
                        {title: window.$t("mis.appProduct.other.setAmountFieldLabel"), placeholder: window.$t("mis.appProduct.other.setAmountFieldPlaceholder"), type: 7, max: 15 ,field: "amount", data: appProductAmount, paddingRight:true },
                    ]
                },
                pageData: {
                    queryUrl: URL.appProduct.appProductList,
                    sequence: true,
                    isPage: false,
                    cols: [
                        {title: window.$t("mis.appProduct.table.iCodeId"), field: "icodeId"},
                        {title: window.$t("mis.appProduct.table.chineseName"), field: "chineseName"},
                        {title: window.$t("mis.appProduct.table.englishName"), field: "englishName"},
                        {title: window.$t("mis.appProduct.table.platform"), field: "platform"},
                        {title: window.$t("mis.appProduct.table.channel"), field: "channel"},
                        {title: window.$t("mis.appProduct.table.accountType"), field: 'accountType'},
                        {title: window.$t("mis.appProduct.table.sortOrder"), field: "order", render:(data)=> {
                            if(data < 0) return "";
                            else return data;
                        }},
                        {title: window.$t("mis.appProduct.table.createdDate"), field: "createDate"},
                        {title: window.$t("mis.appProduct.table.updatedDate"), field: "updateDate", render:(row, data)=> {
                            if(row == null || row == "") return data.createDate;
                            return row;
                        }},
                        {title: window.$t("common.handle"), btnClick: [
                            {name: window.$t("common.edit"), click:"update",type:"primary", icon: "el-icon-edit", auth:"sys:appProduct:update"},
                            {name: window.$t("common.delete"), click:"delete",type:"primary", icon:"el-icon-delete", auth:"sys:appProduct:delete"}    
                        ]}
                    ]
                },
                addAppProductData: {
                    modelName: window.$t("mis.appProduct.addForm.title"),
                    cols: [
                        // {title: "id", field: "id", hidden: true},
                        // {field: "code", hidden: true},
                        // {field: "chineseName", hidden: true},
                        // {title: window.$t("mis.appProduct.addAppProductEnglishNameLabel"), field: "englishName", type: 2, optionList: gts2ProductOptions, required: true}
                    ]
                },
                updateAppProductData: {
                    modelName: window.$t("mis.appProduct.updateForm.title"),
                    cols: [
                        // {title: "id", field: "id", hidden: true},
                        // {title: window.$t("mis.appProduct.updateAppProductEnglishNameLabel"), field: "englishName", type: 2, optionList: gts2ProductOptions, required: true}
                    ]
                },
                deleteAppProductData: {

                }
            }
        },
        created () {
            this.getMetaData();
            this.getAppProductAmount();
        },
        mounted() {
            userInfo = DATA.base.user();
        }
    }
</script>